// components/UploadSection.tsx
import React from 'react';

import { Select } from '../../Select';

interface UploadSectionProps {
  selecionado: string;
  departamentos: any[];
  departamento: string;
  onDepartamentoChange: (valor: any) => void;
  vigencia: string;
  onVigenciaChange: (valor: string) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UploadSection: React.FC<UploadSectionProps> = ({
  selecionado,
  departamentos,
  departamento,
  onDepartamentoChange,
  vigencia,
  onVigenciaChange,
  onFileChange,
}) => {
  return (
    <>
      {/* Seleção de departamento */}
      {selecionado && departamentos.length > 0 && (
        <div className="ml-10">
          <div className="w-1/2 flex flex-col gap-2">
            <Select
              label="Grupo de Faturamento"
              placeholder="Selecione o Grupo de Faturamento/Departamento"
              options={[]}
              optionsFull={departamentos.map(data => ({
                ...data,
                Nome: data.depDescricao,
                Id: data.depId,
              }))}
              value={departamento}
              onChange={e => onDepartamentoChange(e.target.value)}
            />
          </div>
        </div>
      )}

      {/* Upload e vigência */}
      <div className="flex gap-6 w-full">
        <div className="flex flex-col w-2/5">
          <label
            htmlFor="excelFile"
            className="mb-2 font-semibold text-blue-800 p-1"
          >
            Upload da Planilha Excel
          </label>
          <input
            id="excelFile"
            type="file"
            accept=".xlsx, .xls"
            onChange={onFileChange}
            className="px-4 py-2 border border-blue-300 rounded-lg bg-blue-50 text-blue-900 font-medium focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 transition"
          />
        </div>

        <div className="flex flex-col w-1/6">
          <label
            htmlFor="inicioVigencia"
            className="mb-2 font-semibold text-blue-800 p-1"
          >
            Início de Vigência
          </label>
          <input
            id="inicioVigencia"
            type="date"
            value={vigencia}
            onChange={e => onVigenciaChange(e.target.value)}
            className="px-4 py-2 border border-blue-300 rounded-lg bg-blue-50 text-blue-900 font-medium focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 transition"
          />
        </div>
      </div>
    </>
  );
};
